// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"default-src_app_bloc_auth_bloc_ts-src_app_bloc_customer_bloc_ts-node_modules_sweetalert2_dist-48366c":"1ae02fcd9ecf4ac7","src_app_pages_pages_module_ts":"30f5c983e5b310e2","src_app_pages-member_pages-member_module_ts":"48fce596fae20d79"}[chunkId] + ".js";
};